//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.PriceInfo
import com.tixforgigs.apax.models.ResaleState
import com.tixforgigs.apax.models.ResaleType

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The resale data model
* 
* @param id The resale id
* @param priceInfo 
* @param state 
* @param type 
* @param dateFrom The resale is active from date
* @param dateTo The resale is active to date
*/
@Serializable

data class Resale (


      /* The resale id */
    @SerialName(value = "id") @Required val id: kotlin.Int,


      @SerialName(value = "priceInfo") @Required val priceInfo: PriceInfo,


      @SerialName(value = "state") @Required val state: ResaleState,


      @SerialName(value = "type") @Required val type: ResaleType,


      /* The resale is active from date */
    @SerialName(value = "dateFrom") val dateFrom: kotlin.time.Instant? = null,


      /* The resale is active to date */
    @SerialName(value = "dateTo") val dateTo: kotlin.time.Instant? = null


) {




  }

